import { View, Text } from "react-native";
import { Play } from "lucide-react-native";
import { EMBER } from "../../../onboarding/theme";

type Props = {
  caption?: string;
  url?: string;
};

export default function VideoEmbed({ caption }: Props) {
  return (
    <View
      style={{
        borderRadius: 16,
        backgroundColor: "rgba(0,0,0,0.04)",
        borderWidth: 1,
        borderColor: "rgba(0,0,0,0.06)",
        padding: 24,
        alignItems: "center",
        justifyContent: "center",
        minHeight: 160,
        marginTop: 12,
        gap: 12,
      }}
    >
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 24,
          backgroundColor: `${EMBER.colors.warm}14`,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Play size={20} color={EMBER.colors.warm} strokeWidth={2} />
      </View>
      {caption && (
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 13,
            color: EMBER.colors.textMid,
            textAlign: "center",
          }}
        >
          {caption}
        </Text>
      )}
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 10,
          color: EMBER.colors.textFaint,
          fontStyle: "italic",
        }}
      >
        Video coming soon
      </Text>
    </View>
  );
}
